import { Navigate } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { useStaffAuth } from '../lib/staffAuth';
import { isOrgActive } from '../lib/plans';
import LockedFeature from '../pages/LockedFeature';

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F7F8FA]">
        <div className="text-sm text-[#6B7280]">Cargando…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export function GuestOnly({ children }) {
  const { user, loading, memberships } = useAuth();
  if (loading) return null;
  if (user) {
    // Multi-org: si hay 2+ membresías, ir a selector antes del panel
    if ((memberships?.length || 0) > 1) {
      return <Navigate to="/seleccionar-organizacion" replace />;
    }
    return <Navigate to="/app/dashboard" replace />;
  }
  return children;
}

export function RequireActivePlan({ moduleName, children }) {
  const { user, organization } = useAuth();
  // Priviax staff siempre pasa (usa la app como cliente en su propia org)
  if (user?.is_priviax_staff) return children;
  if (isOrgActive(organization)) return children;
  return <LockedFeature moduleName={moduleName} />;
}

export function RequireStaffVerified({ children }) {
  const { isAuthed } = useStaffAuth();
  if (!isAuthed) return <Navigate to="/priviax-login" replace />;
  return children;
}
